import * as React from 'react';

import { InventoryItemButton } from '../InventoryItemButton';

import { InventoryItemRecord } from '~/modules/trade/types/load';

export type InventoryItemsModalGroupsGridProps = {
  groups: InventoryItemRecord[];
  selectedGroupId: string | null;
  onSelectGroup: (groupId: string) => void;
};

export const InventoryItemsModalGroupsGrid = ({
  groups,
  selectedGroupId,
  onSelectGroup,
}: InventoryItemsModalGroupsGridProps) => (
  <div className="@InventoryItemsModalGroupsGrid grid grid-cols-4 gap-2">
    {groups.map((group) => (
      <InventoryItemButton
        key={group.id}
        inventoryItem={group}
        isSelected={selectedGroupId === group.id}
        onPress={() => onSelectGroup(group.id)}
      />
    ))}
  </div>
);
